import React, { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as jnb from "react-bootstrap";
import * as Yup from "yup";
import { config } from "../CommonUtils/CommonURLS";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, allowNumbersAndAlphabetsOnly } from "../CommonUtils/CommonValidations";
import { emailValidation, ERROR_MSG, mobileValidation } from "../CommonUtils/contextVariables";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { successAlert2, failureAlert, SweetalertCancelFunction } from "../CommonUtils/SweetAlerts";
import StudentDetailsForm from "../Student Services/StuServices/StudentDetailsForm";

export default function NocForm({ selectedStudent, setShowCheckModal, fetchStudents, setSubmitting, fromToCollege }) {
  console.log("fromToCollege>>>", fromToCollege);
  const [loading, setLoading] = useState(false);
  const [apiNocDetails, setApiNocDetails] = useState({});
  // console.log("NocForm selectedStudent", selectedStudent?.student_reg_no);
  const initialValues = {
    studentRegNo: selectedStudent?.student_reg_no || "",
    reasonForTransfer: selectedStudent?.transfer_reason || "",
    nocIssuedFor: selectedStudent?.trans_collname || "",
    regAdmissionNo: selectedStudent?.student_reg_no || "",
    candidateName: selectedStudent?.student_name || "",
    fatherName: selectedStudent?.father_name || "",
    yearOfAdmission: String(selectedStudent?.year_of_admission || ""),
    course: selectedStudent?.course_name || "",
    branch: selectedStudent?.branch || "",
    presentAcYear: selectedStudent?.present_ac_year || "",
    semester: selectedStudent?.present_semester || "",
    lateralEntry: typeof selectedStudent?.lateral_entry === "boolean" ? (selectedStudent.lateral_entry ? "Yes" : "No") : "",
    affiliatedUniversity: String(selectedStudent?.ub_code || ""),
    presentDistrictCollege: String(selectedStudent?.present_dist_code || ""),
    presentStudyingCollege: selectedStudent?.prsent_collname || "",
    transferCollegeDistrict: String(selectedStudent?.trans_dist_code || ""),
    transferCollege: selectedStudent?.trans_collname || "",
    affiliatedTransferUniversity: String(selectedStudent?.ub_code || ""),
    yearTransferCollege: selectedStudent?.next_ac_year || "",
    semesterTransferCollege: selectedStudent?.next_semester || "",
    universityGovtNoc: apiNocDetails?.university_govt_noc || "",
    detainedDiscontinued: apiNocDetails?.detained_discontinued || "",
    lastExamYear: apiNocDetails?.last_exam_year || `${selectedStudent?.present_ac_year || ""} - ${selectedStudent?.present_semester || ""}`,
    lastExamDate: apiNocDetails?.last_exam_date ? String(apiNocDetails?.lastExamDate || apiNocDetails?.last_exam_date).split("T")[0] : "",
    typeOfSeatAdmitted: apiNocDetails?.type_of_seat_admitted || "",
    annualTuitionFee: apiNocDetails?.annual_tuition_fee || "",
    nocNumber: apiNocDetails?.noc_number || "",
    unfilledSeatsCount: apiNocDetails?.unfilled_seats_count || "",
    nocCeilingLimit: apiNocDetails?.noc_ceiling_limit || "",
    typeOfSeatTransfer: apiNocDetails?.type_of_seat_transfer || "",
    annualTuitionFeeNewInst: apiNocDetails?.annual_tuition_fee_new_inst || "",
    principalName: apiNocDetails?.principal_name || "",
    principalMobileNo: apiNocDetails?.principal_mobile_no || "",
    principalEmailId: apiNocDetails?.principal_email_id || "",
  };

  const validationSchema = Yup.object().shape({
    reasonForTransfer: Yup.string().required(ERROR_MSG),
    nocIssuedFor: Yup.string().required(ERROR_MSG),
    regAdmissionNo: Yup.string().required(ERROR_MSG),
    candidateName: Yup.string().required(ERROR_MSG),
    fatherName: Yup.string().required(ERROR_MSG),
    yearOfAdmission: Yup.string().required(ERROR_MSG),
    course: Yup.string().required(ERROR_MSG),
    branch: Yup.string().required(ERROR_MSG),
    presentAcYear: Yup.string().required(ERROR_MSG),
    // semester: Yup.string().required(ERROR_MSG),
    lateralEntry: Yup.string().required(ERROR_MSG),
    affiliatedUniversity: Yup.string().required(ERROR_MSG),
    presentDistrictCollege: Yup.string().required(ERROR_MSG),
    presentStudyingCollege: Yup.string().required(ERROR_MSG),
    transferCollegeDistrict: Yup.string().required(ERROR_MSG),
    transferCollege: Yup.string().required(ERROR_MSG),
    affiliatedTransferUniversity: Yup.string().required(ERROR_MSG),
    yearTransferCollege: Yup.string().required(ERROR_MSG),
    // semesterTransferCollege: Yup.string().required(ERROR_MSG),
    universityGovtNoc: Yup.string().required(ERROR_MSG),
    detainedDiscontinued: Yup.string().required(ERROR_MSG),
    lastExamYear: Yup.string().required(ERROR_MSG),
    lastExamDate: Yup.string().required(ERROR_MSG),
    typeOfSeatAdmitted: Yup.string().required(ERROR_MSG),
    annualTuitionFee: Yup.string().required(ERROR_MSG),
    nocNumber: Yup.string().required(ERROR_MSG),
    unfilledSeatsCount: Yup.string().required(ERROR_MSG),
    nocCeilingLimit: Yup.string().required(ERROR_MSG),
    typeOfSeatTransfer: Yup.string().required(ERROR_MSG),
    annualTuitionFeeNewInst: Yup.string().required(ERROR_MSG),
    principalName: Yup.string().required(ERROR_MSG),
    principalMobileNo: mobileValidation,
    principalEmailId: emailValidation,
  });

  const nocFormik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: handleNocFormSubmit,
  });

  const currentYear = new Date().getFullYear();
  const baseAdmissionYears = Array.from({ length: 5 }, (_, index) => String(currentYear - 4 + index));
  const selectedAdmissionYear = String(nocFormik.values.yearOfAdmission || "");
  const admissionYearOptions = selectedAdmissionYear && !baseAdmissionYears.includes(selectedAdmissionYear) ? [selectedAdmissionYear, ...baseAdmissionYears] : baseAdmissionYears;

  async function handleNocFormSubmit(values) {
    const confirm = await SweetalertCancelFunction("Are you sure you want to submit?", "warning");
    if (!confirm?.isConfirmed) return;
    setSubmitting(true);
    setLoading(true);
    try {
      const payload = {
        studentRegNo: values.studentRegNo,
        universityGovtNoc: values.universityGovtNoc,
        detainedDiscontinued: values.detainedDiscontinued,
        lastExamYear: values.lastExamYear,
        lastExamDate: values.lastExamDate,
        typeOfSeatAdmitted: values.typeOfSeatAdmitted,
        annualTuitionFee: values.annualTuitionFee,
        nocNumber: values.nocNumber,
        unfilledSeatsCount: values.unfilledSeatsCount,
        nocCeilingLimit: values.nocCeilingLimit,
        typeOfSeatTransfer: values.typeOfSeatTransfer,
        annualTuitionFeeNewInst: values.annualTuitionFeeNewInst,
        principalName: values.principalName,
        principalMobileNo: values.principalMobileNo,
        principalEmailId: values.principalEmailId,
        fromToCollege: fromToCollege,
        nocStatus: "Approved",
      };

      const res = await CommonAxiosPost(`${config.url.STU_URL}saveStudentnoc`, payload);
      if (res?.data?.status === true || res?.data?.scode === "01") {
        successAlert2(res?.data?.message || "NOC Form submitted successfully");
        setShowCheckModal(false);
        fetchStudents();
      } else {
        failureAlert(res?.data?.message || "Failed to submit NOC Form");
      }
    } catch (error) {
      console.error("Error submitting NOC Form:", error);
      failureAlert("Error submitting NOC Form");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  }
  // ✅ Get API
  function GetNocDetails() {
    if (!selectedStudent?.student_reg_no) return;
    let url = `${config.url.STU_URL}getStudentnoc_dtls/${selectedStudent?.student_reg_no}/${fromToCollege}`;
    CommonAxiosGet(url)
      .then((response) => {
        if (response?.data?.status === true) {
          const data = Array.isArray(response?.data?.data) ? response?.data?.data[0] : response?.data?.data;
          setApiNocDetails(data || {});
        } else {
          setApiNocDetails({});
        }
      })
      .catch((error) => {
        console.error("Error fetching NOC details:", error);
      });
  }

  useEffect(() => {
    GetNocDetails();
  }, [selectedStudent?.student_reg_no]);

  const isNocAlreadySubmitted = apiNocDetails && Object.keys(apiNocDetails).length > 0 && apiNocDetails.noc_number;

  return (
    <jnb.Container fluid className="st-form-page py-3">
      <FormikProvider value={nocFormik}>
        <Form onSubmit={nocFormik.handleSubmit} id="noc-form">
          <StudentDetailsForm paymentFlag={true} studentRegNo={selectedStudent?.student_reg_no} />

          {/* Section 4: NOC & Eligibility Details */}
          <section className="st-form-card">
            <div className="st-form-card-header">
              <span className="st-form-card-index">4</span>
              <h5>NOC & Eligibility</h5>
            </div>
            <jnb.Row className="g-3 g-lg-4 p-3 p-lg-4">
              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Whether University/Govt Issued NOC <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field as="select" name="universityGovtNoc" className="form-select st-control" disabled={isNocAlreadySubmitted}>
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
                <ErrorMessage name="universityGovtNoc" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Whether the student get Detained/Discontinued in Previous Years <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field as="select" name="detainedDiscontinued" className="form-select st-control" disabled={isNocAlreadySubmitted}>
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Field>
                <ErrorMessage name="detainedDiscontinued" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Last Examination Year/Semester <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="lastExamYear" className="form-control st-control" placeholder="e.g., I-II" maxLength={10} disabled />
                <ErrorMessage name="lastExamYear" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Last Examination Date <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="lastExamDate" type="date" className="form-control st-control" disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="lastExamDate" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Type of Seat (Admitted) <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field as="select" name="typeOfSeatAdmitted" className="form-select st-control" disabled={isNocAlreadySubmitted}>
                  <option value="">Select</option>
                  <option value="Convenor Quota">Convenor Quota</option>
                  <option value="Management Quota">Management Quota</option>
                </Field>
                <ErrorMessage name="typeOfSeatAdmitted" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Annual tuition fee paid by the candidate & Amount due from him in case transfer is effected at present studying college <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="annualTuitionFee" className="form-control st-control" maxLength={20} onKeyPress={allowNumbersOnly} disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="annualTuitionFee" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  NOC Number <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="nocNumber" className="form-control st-control" maxLength={50} disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="nocNumber" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Whether the NOC issued against 1% ceiling limit or Unfilled vacancy? <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field as="select" name="nocCeilingLimit" className="form-select st-control" disabled={isNocAlreadySubmitted}>
                  <option value="">Select</option>
                  <option value="1% Ceiling">1% Ceiling</option>
                  <option value="Unfilled Vacancy">Unfilled Vacancy</option>
                </Field>
                <ErrorMessage name="nocCeilingLimit" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Number of Unfilled Seats in the year-sem for which student seeking transfer <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="unfilledSeatsCount" className="form-control st-control" maxLength={50} placeholder="e.g., Total intake - 300, CQ-0, MQ-0" disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="unfilledSeatsCount" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Type of Seat (Transfer) <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field as="select" name="typeOfSeatTransfer" className="form-select st-control" disabled={isNocAlreadySubmitted}>
                  <option value="">Select</option>
                  {nocFormik?.values?.typeOfSeatAdmitted === "Convenor Quota" && <option value="Convenor Quota">Convenor Quota</option>}
                  <option value="Management Quota">Management Quota</option>
                </Field>
                <ErrorMessage name="typeOfSeatTransfer" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Annual Tuition Fee (New Institution) <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="annualTuitionFeeNewInst" className="form-control st-control" maxLength={20} onKeyPress={allowNumbersOnly} disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="annualTuitionFeeNewInst" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>
            </jnb.Row>
          </section>

          {/* Section 5: Principal Details */}
          <section className="st-form-card">
            <div className="st-form-card-header">
              <span className="st-form-card-index">5</span>
              <h5>Principal Details</h5>
            </div>
            <jnb.Row className="g-3 g-lg-4 p-3 p-lg-4">
              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Name of the Principal <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="principalName" className="form-control st-control" maxLength={100} onKeyPress={allowAlphabetAndSpacesOnly} disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="principalName" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Principal Mobile No <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="principalMobileNo" className="form-control st-control" maxLength={10} onKeyPress={allowNumbersOnly} disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="principalMobileNo" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>

              <jnb.Col xs={12} md={6} lg={4}>
                <jnb.Form.Label className="st-label">
                  Principal Email ID <span className="text-danger">*</span>
                </jnb.Form.Label>
                <Field name="principalEmailId" type="email" className="form-control st-control" maxLength={100} disabled={isNocAlreadySubmitted} />
                <ErrorMessage name="principalEmailId" component="div" className="text-danger extra-small mt-1" />
              </jnb.Col>
            </jnb.Row>
          </section>

          {/* Submit Button */}
          <jnb.Row className="g-3 mt-4 mb-4 p-3 p-lg-4">
            <jnb.Col className="d-flex gap-2 justify-content-center">
              {isNocAlreadySubmitted ? (
                <span className="fw-bold text-success">✓ Already Submitted</span>
              ) : (
                <>
                  <jnb.Button variant="secondary" type="button" disabled={loading} onClick={() => setShowCheckModal(false)}>
                    Cancel
                  </jnb.Button>

                  <jnb.Button variant="primary" type="submit" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                  </jnb.Button>
                </>
              )}
            </jnb.Col>
          </jnb.Row>
        </Form>
      </FormikProvider>
    </jnb.Container>
  );
}
